export const HOME = '/';
export const LOGIN = '/login';
export const SIGNUP = '/signup';
export const TIPS = '/tips';
export const REPORT = '/report';
export const DASHBOARD = '/dashboard';
export const HEADER = '/header';
export const NOMATCH = '*';
